const guides = [
  {
    id: 1,
    name: "Pasang Sherpa",
    role: "Team Leader",
    village: "Memerku, Solukhumbu",
    image: "/assets/images/Pasang.jpeg",
    summits: 3,
    specialties: [
      "High Altitude Rescue",
      "Cultural Interpretation",
      "Photography Guide",
      "Monastery Connections",
    ],
    story: `Born in the shadow of Everest, Pasang grew up watching expeditions pass through his village. His grandfather was among the first Sherpa guides to summit Everest with early expeditions. Following family tradition, Pasang began his guiding career at 19 and has since become one of Nepal's most respected high-altitude guides.\n\nPasang's deep connection to Buddhist philosophy and his fluency in five languages make him exceptional at bridging cultures. He's known for his calm presence during challenging conditions and his ability to share the spiritual significance of the mountains with trekkers.`,
    mountains: [
      { name: "Mera Peak", elevation: "6,476m", summits: 1 },
      { name: "Island Peak", elevation: "6,189m", summits: 1 },
      { name: "Labuche", elevation: "6,119m", summits: 1 },
    ],
  },
  {
    id: 2,
    name: "Yangji Sherpa",
    village: "Memerku, Solukhumbu",
    image: "/assets/images/Yangji.jpeg",
    experience: 15,
    rating: 4.9,
    specialties: [
      "Monastery Connections",
      "Youth Mentoring",
    ],
    story: `Yangji Sherpa, Sales and marketing officer of Sherpa trekker has joined our company since 20th May 2022 as intern firstly but gradually she joined our team as full time marketing officer since June 2023. She is originally from Mamerku-Solukhumbu, currently living in Gokarna. She has completed her  higher school from Trinity International College located in Dillibazar in the year 2019, She later completed her bachelors in Travel and  Tourism from International School of Tourism and Hotel Management with3.37 GPA in the year 2023. She has been working as a Sales officer where she interacts directly with customers to know about their preferences regarding the itinerary program, helping them to choose the perfect destination, maintaining a good relationship with the customers  and  updating the programs on social media and websites.
`,
    testimonials: [
      {
        name: "Lisa Park",
        trek: "Photography Expedition",
        rating: 5,
        comment:
          "Tenzin's photography guidance helped me capture stunning images while learning about Sherpa culture. His technical skills are outstanding.",
      },
      {
        name: "James Wilson",
        trek: "Cho Oyu Expedition",
        rating: 5,
        comment:
          "Professional, safety-focused, and incredibly knowledgeable. Tenzin's mentoring approach built my confidence throughout the climb.",
      },
    ],
  },
  {
    id: 3,
    name: "Da Chhetar Sherpa",
    village: "Memerku, Solukhumbu",
    image: "/assets/images/Da-Chettar.jpeg",
    experience: 15,
    rating: 4.9,
    summits: 21,
    expeditions: 124,
    specialties: [
      "Photography Guide",
      "Monastery Connections",
      "High Altitude Rescue",
      "Youth Mentoring",
    ],
    story: `Da carries forward the proud tradition of Sherpa mountaineering excellence. Born in Memerku, the village that produced many famous climbers, he was inspired by stories of early Everest expeditions.\n\nDa specializes in photography expeditions and has an exceptional eye for capturing the beauty of the Himalayas. His technical climbing skills are matched by his ability to mentor young climbers and share the rich history of Sherpa mountaineering achievements.`,
    mountains: [
      { name: "Chili Far East", elevation: "6,059m", summits: 1 },
      { name: "Manaslu", elevation: "8,163m", summits: 5 },
      { name: "Mera Peak", elevation: "6,476m", summits: 1 },
      { name: "Dhaulagiri", elevation: "8,167m", summits: "Camp-1" },
      { name: "Everest", elevation: "8,848m", summits: 4 },
      { name: "Amadablam", elevation: "6,812m", summits: 3 },
      { name: "Lhotse South Face", elevation: "8,516m", summits: "Camp-4" },
      { name: "Lhotse", elevation: "8,516m", summits: 2 },
      { name: "K2", elevation: "8,611m", summits: 1 },
        { name: "Annapurna", elevation: "8,091m", summits: 2 },
    ],
    testimonials: [
      {
        name: "Lisa Park",
        trek: "Photography Expedition",
        rating: 5,
        comment:
          "Tenzin's photography guidance helped me capture stunning images while learning about Sherpa culture. His technical skills are outstanding.",
      },
      {
        name: "James Wilson",
        trek: "Cho Oyu Expedition",
        rating: 5,
        comment:
          "Professional, safety-focused, and incredibly knowledgeable. Tenzin's mentoring approach built my confidence throughout the climb.",
      },
    ],
  },
  {
    id: 4,
    name: "Pem Tenji Sherpa",
    village: "Memerku, Solukhumbu",
    image: "/assets/images/Pemtenji.jpeg",
    summits: 9,
    specialties: [
      "Traditional Crafts",
      "Festival Expert",
      "Wildlife Tracking",
      "Meditation Guide",
    ],
    story: `Pem Tenji comes from a long line of mountain guides and traditional craftsmen. His village of Memerku is famous for its monastery and traditional Sherpa architecture. Pem Tenji learned the ancient art of wood carving from his father and incorporates cultural education into every trek.\n\nKnown for his gentle teaching style and deep meditation practice, Pem Tenji helps trekkers connect with the spiritual aspects of mountain travel. He's particularly skilled at timing treks with local festivals, offering authentic cultural immersion experiences.`,
    certifications: ["/assets/images/Certi.jpeg"],
    mountains: [
      { name: "Island Peak", elevation: "6,189m", summits: 3 },
      { name: "Phapchermo", elevation: "6,273m", summits: 1 },
      { name: "Mera Peak", elevation: "6,476m", summits: 2 },
      { name: "Mount Everest", elevation: "8,849", summits: 3 },
    ],
    testimonials: [
      {
        name: "Emma Thompson",
        trek: "Gokyo Lakes Trek",
        rating: 5,
        comment:
          "Ang Dorje's cultural insights and meditation sessions made this trek deeply meaningful. His craftsmanship demonstrations were fascinating.",
      },
      {
        name: "Michael Rodriguez",
        trek: "Ama Dablam Base Camp",
        rating: 5,
        comment:
          "Incredible guide who combines technical expertise with profound cultural knowledge. The festival timing was perfect!",
      },
    ],
  },
  {
    id: 5,
    name: "Ngima Dorje Lama",
    village: "Sano Pakhar, Sindhupalchowk",
    image: "/assets/images/Nima-D.jpeg",
    experience: 15,
    rating: 4.9,
    summits: 3,
    expeditions: 124,
    specialties: [
      "Photography Guide",
      "Monastery Connections",
      "High Altitude Rescue",
      "Youth Mentoring",
    ],
    story: `Da carries forward the proud tradition of Sherpa mountaineering excellence. Born in Thame, the village that produced many famous climbers, he was inspired by stories of early Everest expeditions.\n\nDa specializes in photography expeditions and has an exceptional eye for capturing the beauty of the Himalayas. His technical climbing skills are matched by his ability to mentor young climbers and share the rich history of Sherpa mountaineering achievements.`,
    mountains: [
      { name: "Mera Peak", elevation: "6,476m", summits: 1 },
      { name: "Island Peak", elevation: "6,189m", summits: 1 },
      { name: "Labuche", elevation: "6,119m", summits: 1 },
    ],
    testimonials: [
      {
        name: "Lisa Park",
        trek: "Photography Expedition",
        rating: 5,
        comment:
          "Tenzin's photography guidance helped me capture stunning images while learning about Sherpa culture. His technical skills are outstanding.",
      },
      {
        name: "James Wilson",
        trek: "Cho Oyu Expedition",
        rating: 5,
        comment:
          "Professional, safety-focused, and incredibly knowledgeable. Tenzin's mentoring approach built my confidence throughout the climb.",
      },
    ],
  },
];

export default guides;

export function getGuideById(id) {
  return guides.find((g) => g.id === Number(id));
}
